module.exports = __webpack_public_path__ + "static/img/news_tu5.a859eac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_tu5.png
// module id = G00Y
// module chunks = 0